<template>
  <div class="steps-con">
    <div class="step" :class="{'active': activeStep === 1}">
      <div class="number">1</div>
      <div class="text">Allocatable Items</div>
    </div>
    <div class="border"></div>
    <div class="step" :class="{'active':activeStep===2}">
      <div class="number">2</div>
      <div class="text">PO Required?</div>
    </div>
    <div class="border"></div>
    <div class="step" :class="{'active':activeStep===3}">
      <div class="number">3</div>
      <div class="text">Select a ship to address</div>
    </div>
    <div class="border"></div>
    <div class="step" :class="{'active':activeStep===4}">
      <div class="number">4</div>
      <div class="text">Special Instructions</div>
    </div>
    <div class="border"></div>
    <div class="step" :class="{'active':activeStep===5}">
      <div class="number">5</div>
      <div class="text">Allocate Items</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepsHeader',
  props: {
    activeStep: Number
  },
  computed: {

  },
  mounted() {

  },
  methods: {}
}
</script>